module.exports = __webpack_public_path__ + "img/pd_m_2.b7801ae5.jpg";